module.exports = __webpack_public_path__ + "img/sec1_box2.5db73f7f.jpg";